// initial state
const state = {
  pageTitle: '',
  drawer: true
};

// actions
const actions = {};

// mutations
const mutations = {
  setPageTitle(state, pageTitle) {
    state.pageTitle = pageTitle;
  },
  toggleDrawer(state) {
    state.drawer = !state.drawer;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
